export default {
  TEMPLATE_ID_PROP: 'mgnl:template',
  END_AREA_COMMENT: '/cms:area',
  END_COMPONENT_COMMENT: '/cms:component',
} as const;
